import React, { useContext, useEffect } from "react";
import Index from "../../component/Index";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { getUserSettings } from "../../redux/user/action";
import { ThemeContext } from "../../theme/ThemeContext";

const PrivateLayout = ({ children }) => {
  const location = Index.useLocation();
  const dispatch = Index.useDispatch();
  const navigate = useNavigate();
  const { setTheme } = useContext(ThemeContext);

  const { isUserLogin: UserLoggedIn, token } = Index.useSelector(
    (state) => state.UserReducer
  );

  const handleResize = () => {
    if (window.innerWidth < 992) {
      const size = {
        width: window.innerWidth,
        height: window.innerHeight,
      };
      
      getUserSettings(dispatch, token, setTheme, null, size);
    }
  };
  
  useEffect(() => {
    const size = {
      width: window.innerWidth,
      height: window.innerHeight,
    };
    getUserSettings(dispatch, token, setTheme, null, size);
    window.addEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (location.pathname === "/user" || location.pathname === "/user/") {
      navigate("/user/dashboard");
    }
  }, [location]);

  return UserLoggedIn ? (
    <Outlet />
  ) : (
    <Navigate to="/" state={{ from: location }} replace={true} />
  );
  // return <Outlet />
};

export default PrivateLayout;
